import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import ProductCard from '@components/product/ProductCard/NewProductCard'
import { Autoplay, Navigation } from 'swiper'
import IntersectionObserverComponent, {
  IItem,
} from '@components/utils/IntersectionObserverComponent'
import { getCategories, getMinHeights } from '@framework/utils/app-util'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { useState } from 'react'
import dynamic from 'next/dynamic'
import { VIEW_TYPE } from './helper'
import { isMobileOnly } from 'react-device-detect'
import { groupBy } from '@framework/utils/lodash'
import { IS_BESTSELLER_VERTICAL_VISIBLE } from '@framework/utils/constants'
import { useRouter } from 'next/router'

const QuickViewModal = dynamic(
  () => import('@components/product/QuickView/ProductQuickView'),
  {
    ssr: false,
  }
)

const ProductCollectionSwiper = ({
  data,
  deviceInfo,
  title,
  viewType,
  redirectionUrl,
  cmsNoPaddingLayout,
}: any) => {
  const [quickViewProductSlug, setQuickViewProductSlug] = useState<
    string | null
  >(null)
  const router = useRouter()
  let products: any = { results: [] }
  if (data && data.length) {
    products.results = data?.slice(0, 12)
  }
  let items: IItem[] = []
  if (products?.results && products?.results?.length) {
    items = products?.results?.map((product: any, index: number) => {
      let color = ''
      if (product?.variantGroupCode) {
        color = product.variantGroupCode.split('-')[1]
      }
      return {
        item_name: product.name,
        item_id: product.sku,
        price: product.price.raw.withTax,
        item_brand: product.brand,
        item_category: getCategories(product).category,
        item_category2: getCategories(product).category2,
        item_variant: color,
        color,
        item_list_name: getCategories(product).category,
        // item_list_id: number;
        index,
        item_var_id: product.stockCode,
      }
    })
  }

  const redirectToPage = () => {
    if (redirectionUrl) {
      router.push(redirectionUrl)
    }
  }

  return (
    <div className="flex flex-col px-0 pb-4 pr-0 bg-transparent row-end-auto sm:px-0 sm:pr-0 sm:pb-6 m-hide-navigation">
      <IntersectionObserverComponent
        title={title ?? 'Home Page Products'}
        eventName={GA_EVENT.VIEW_ITEM_LIST}
        items={items}
        _threshold={
          viewType === VIEW_TYPE.VERTICAL &&
          isMobileOnly &&
          IS_BESTSELLER_VERTICAL_VISIBLE
            ? 0.2
            : undefined
        }
      >
        {viewType === VIEW_TYPE.VERTICAL &&
        isMobileOnly &&
        IS_BESTSELLER_VERTICAL_VISIBLE ? (
          <>
            <div
              className={`grid grid-cols-2 w-full sm:gap-y-1 md:grid-cols-4 product-listing-main lg:grid-cols-4`}
            >
              {products?.results &&
                products?.results?.map((item: any, index: number) => {
                  const { plpmsg1Height, plpmsg3Height } = getMinHeights(isMobileOnly, index, item, products);
                  return (
                    <div key={index}>
                      <ProductCard
                        key={index}
                        product={item}
                        collectionId={index}
                        collectionName={
                          viewType === VIEW_TYPE.VERTICAL
                            ? 'Bestseller Vertical'
                            : 'Bestseller'
                        }
                        position={index + 1}
                        deviceInfo={deviceInfo}
                        setQuickViewProductSlug={(payload: string | null) => {
                          setQuickViewProductSlug(payload)
                        }}
                        _plpmsg1Height={plpmsg1Height}
                        _plpmsg3Height={plpmsg3Height}
                      />
                    </div>
                  )
                })}
            </div>
            <div className="w-full mt-1.5 flex  justify-center items-center">
              <button
                className="border  border-[#25100029]  rounded-[36px] py-[12px] px-[18px] gap-2"
                onClick={() => {
                  redirectToPage()
                }}
              >
                <span className="text-[#EB5B25] text-[16px] font-medium">
                  View All Products →
                </span>
              </button>
            </div>
          </>
        ) : (
          <Swiper
            slidesPerView={2.3}
            spaceBetween={4}
            navigation={true}
            loop={false}
            freeMode={true}
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            slidesOffsetBefore={16}
            breakpoints={{
              640: {
                slidesPerView: 2.3,
                // spaceBetween: 4
              },
              768: {
                slidesPerView: cmsNoPaddingLayout ? 2.3 : 3.3,
                // spaceBetween: 4
              },
              1024: {
                slidesPerView: cmsNoPaddingLayout ? 2.3 : 5.5,
                // spaceBetween: 4
              },
            }}
            className="mySwiper"
          >
            {products?.results &&
                products?.results?.map((product?: any, ipx?: number) => {
                  const { plpmsg1Height, plpmsg3Height } = getMinHeights(isMobileOnly, ipx, product, products, true);
                  return (
                    <SwiperSlide key={ipx} style={{ textAlign: 'left' }}>
                      <ProductCard
                        product={product}
                        collectionId={ipx}
                        collectionName={
                          viewType === VIEW_TYPE.VERTICAL
                            ? 'Bestseller Vertical'
                            : 'Bestseller'
                        }
                        position={ipx}
                        deviceInfo={deviceInfo}
                        setQuickViewProductSlug={(payload: string | null) => {
                          setQuickViewProductSlug(payload)
                        }}
                        _plpmsg1Height={plpmsg1Height}
                        _plpmsg3Height={plpmsg3Height}
                      />
                    </SwiperSlide>
                  )}
                )}
            </Swiper>
        )}
      </IntersectionObserverComponent>
      {quickViewProductSlug && (
        <QuickViewModal
          quickViewProductSlug={quickViewProductSlug}
          setQuickview={(payload: string | null) => {
            setQuickViewProductSlug(payload)
          }}
          collectionName={`home-page`}
          deviceInfo={deviceInfo}
          title={title}
          page={'home quick view'}
        />
      )}
    </div>
  )
}

export default ProductCollectionSwiper
